import { writable } from "svelte/store"

/**
 * @typedef Alert
 * @prop {"success"|"error"} status
 * @prop {number} id
 * @prop {string} message
 * @prop {string} [description]
 * @prop {boolean=} isHtmlMessage
 * @typedef AlertWithDuration
 * @prop {string} message
 * @prop {string=} [description]
 * @prop {number=} durationSeconds
 * @prop {boolean=} isHtmlMessage
 */

/** @type {import("svelte/store").Writable<Alert[]>} */
const store = writable([])

/**
 * @param {Pick<Alert, "status" | "message" | "description"| "isHtmlMessage"> & { duration: number }} alert
 * @returns {void}
 */
function send({ duration, ...alert }) {
  const id = Date.now()
  store.update((alerts) => [ ...alerts, { ...alert, id } ])
  setTimeout(() => store.update((alerts) => alerts.filter((item) => item.id !== id)), duration)
}

export default {
  subscribe: store.subscribe,
  /**
   * @param {AlertWithDuration} alertWithDuration
   */
  success({ message, description = "", durationSeconds = 10, isHtmlMessage = false }) {
    const duration = durationSeconds * 1000
    send({
      message,
      description,
      status: "success",
      duration,
      isHtmlMessage,
    })
  },
  /**
   * @param {Alert} alert
   */
  dismiss(alert) {
    store.update((alerts) => alerts.filter((item) => item !== alert))
  },
  /**
   * @param {AlertWithDuration} alertWithDuration
   */
  error({ message, description = "", durationSeconds = 10, isHtmlMessage = false }) {
    const duration = durationSeconds * 1000
    send({
      message,
      description,
      status: "error",
      duration,
      isHtmlMessage,
    })
  },
}
